import type { ApiExplorerTheme } from './api-explorer.models';

/** Fallback theme when no app-specific theme is provided. */
export const DEFAULT_API_EXPLORER_THEME: ApiExplorerTheme = {
  accent: '#148fcb',
  accent10: 'rgba(20, 143, 203, 0.1)',
  accent15: 'rgba(20, 143, 203, 0.15)',
  accent20: 'rgba(20, 143, 203, 0.2)',
  primaryColor: '#283a89',
  primaryButtonGradientEnd: '#3a4e9e',
  textDark: '#1f2937',
  textSecondary: '#6b7280',
  borderColor: '#e5e7eb',
  bgLight: '#f0f9ff',
  surface: '#ffffff',
  modalBackground: 'linear-gradient(180deg, #f8fbfd 0%, #ffffff 100%)',
  operationsPanelBorder: 'rgba(20, 143, 203, 0.15)',
  operationsPanelBackground: 'linear-gradient(180deg, #f8fcff 0%, #eef7fc 100%)',
  responseCardBorder: 'rgba(20, 143, 203, 0.15)',
  responseCardBackground:
    'linear-gradient(180deg, rgba(248, 252, 255, 0.9) 0%, rgba(255, 255, 255, 1) 24%), #ffffff',
  cardBorder: 'rgba(20, 143, 203, 0.15)',
  cardBackground: 'rgba(255, 255, 255, 0.9)',
  cardActiveBorder: '#148fcb',
  cardActiveBackground: 'linear-gradient(180deg, #f2f9ff 0%, #ffffff 100%)',
  cardActiveShadow: 'rgba(20, 143, 203, 0.1)',
  cardActiveSummaryBackground: 'linear-gradient(180deg, #eaf5fc 0%, #f6fbff 100%)',
  cardActiveText: '#148fcb',
  summaryBackground: 'linear-gradient(180deg, #fcfeff 0%, #f7fbfd 100%)',
  dialogHeaderBorder: '#e5e7eb',
  focusRing: 'rgba(20, 143, 203, 0.1)',
};
